export default {
    'toolbar.chrome.print': 'Browser Print',
    'toolbar.print': 'Print',
    'toolbar.preview': 'Preview',
    'toolbar.download': 'Download',
    'toolbar.clear': 'Clear',
    'toolbar.save': 'Save',
    'toolbar.widget': 'Widget',
    'toolbar.page': 'Page',
    'toolbar.printer.setting': 'Printer Settings',

    'toolbar.history': 'History',
    'toolbar.setting': 'Settings',

    'toolbar.style.blob': 'Bold',

    'toolbar.style.italic': 'Italic',
    'toolbar.style.underline': 'Underline',
    'toolbar.style.lineThrough': 'Strikethrough',

    'toolbar.style.textAlignLeft': 'Align Left',
    'toolbar.style.textAlignCenter': 'Align Center',
    'toolbar.style.alignHorizontalCenter': 'Align Horizontally Center',
    'toolbar.style.textAlignRight': 'Align Right',
    'toolbar.style.verticalAlignTop': 'Align Top',
    'toolbar.style.alignTop': 'Align to Top',
    'toolbar.style.verticalAlignCenter': 'Align Vertically Center',
    'toolbar.style.alignVerticalCenter': 'Align Vertically Center',
    'toolbar.style.verticalAlignBottom': 'Align Bottom',
    'toolbar.style.alignBottom': 'Align to Bottom',
    'toolbar.style.arrangeHorizontalSpacing': 'Distribute Horizontally',
    'toolbar.style.arrangeVerticalSpacing': 'Distribute Vertically',
    'toolbar.style.lineBreak': 'Line Break',
    'toolbar.style.borderAll': 'Borders',
    'toolbar.style.group': 'Group',
    'toolbar.style.unGroup': 'Ungroup',

    'toolbar.printer': 'Printer',
    'toolbar.layer.top': 'Bring to Front',
    'toolbar.layer.up.one': 'Bring Forward',
    'toolbar.layer.bottom': 'Send to Back',
    'toolbar.layer.down.one': 'Send Backward'
};
